import React from 'react';

const Caso = props => {
  const { author, year, title, city, state, country, editorial, url } = props;
  return (
    <li>
      <div className="quote">
        <span className="case">
          {
            // autor
            author && author
          }
          {
            // año
            year && ` (${year}). `
          }
          {
            // titulo
            title && <em>{`${title}. `}</em>
          }
          {
            // city
            city && `${city}, `
          }
          {
            // state
            state && `${state}, `
          }
          {
            // country
            country && `${country}: `
          }
          {
            // editorial
            editorial && `${editorial}.`
          }
        </span>
        {
          // url
          url && (
            <a className="quote-url" href={url}>
              Link
            </a>
          )
        }
      </div>
    </li>
  );
};

export default Caso;
